import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Contract } from "@edp-components/edp-contract";
import { FileUpload } from "@edp-models/file-upload.model";
import { AddUploadedFile, ClearUploadedFiles, UploadCustomerSupportFile } from "@edp-store/actions/file-upload.actions";
import { getUploadedFiles } from "@edp-store/selectors/file-upload.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { getMimeType } from "@edp-utils/get-mimetype.utils";
import { checkFieldsArray } from "@edp-validators/check-fields-array.validator";
import { select, Store } from "@ngrx/store";

@Component({
    selector: "create-request-form",
    templateUrl: "./create-request-form.component.html",
    styleUrls: ["./create-request-form.component.scss"],
})
export class CreateRequestFormComponent implements OnInit, OnDestroy {
    @Input() request: any;
    @Input() selectedContract: Contract;
    @Input() btnText: string;
    @Output() submitForm = new EventEmitter();
    @Output() goBack = new EventEmitter();

    public form: FormGroup;
    public numChar = 0;
    public limitChar = 300;
    public isGasCertification = false;
    public isEnergyCertification = false;
    public showDefaultFilesUpload = true;
    public argsFileGas = {
        certification: "Z_CERT_GAS",
        declaration: "Z_AUTO_DEC",
    };
    public argsFileCertification = {
        fileCPU: "ZCE_CPU", // Caderneta Predial Urbana
        fileCRP: "ZCE_CRP", // Certidão Registo Predial
        fileTRTO: "ZCE_TRTO", // Termo Responsabilidade Técnica da Obra
        filePCT: "ZCE_PCT", // Projeto Comportamento Térmico
        fileOther: "ZCE_OUTROS"
    };

    constructor(private fb: FormBuilder, private store: Store<IAppState>) {
        this.form = this.fb.group({
            description: new FormControl("", Validators.maxLength(300)),
            files: new FormControl([]),
            data: new FormControl(null),
            recaptchaToken: new FormControl(null, Validators.required),
        });
    }

    ngOnInit() {
        this.store.pipe(select(getUploadedFiles)).subscribe((files: FileUpload[]) => {
            this.form.get("files").setValue(files);
        });

        this.setFieldsValidation(this.request.selectedMotive.externalCategory);
        this.form.updateValueAndValidity();
    }

    ngOnDestroy() {
        this.store.dispatch(new ClearUploadedFiles());
    }

    public onUploadFile(event) {
        const id = Date.now();
        const mimeType = getMimeType(event.name);

        this.store.dispatch(new AddUploadedFile({ ...event, ...{ mimeType, id } }));

        this.store.dispatch(
            new UploadCustomerSupportFile({
                name: event.name,
                size: event.size,
                base64: event.file,
                modified: null,
                error: null,
                mimeType,
                id,
            })
        );
    }

    public setData(event) {
        this.form.get("data").setValue(event);
    }

    public submit() {
        if (this.form.valid) {
            this.submitForm.emit(this.form.value);
        }
    }

    private setFieldsValidation(externalCategory) {
        switch (externalCategory) {
            case "02180200": // CERTIFICACAO ENERGETICA
                this.isEnergyCertification = this.request.selectedMotive.motiveId === "MOT02";
                this.isGasCertification = this.request.selectedMotive.motiveId === "MOT03";
                this.showDefaultFilesUpload = !this.isGasCertification && !this.isEnergyCertification;
                const validators = this.isGasCertification
                    ? [
                          Validators.required,
                          Validators.minLength(1),
                          checkFieldsArray("ArchObj", [this.argsFileGas.declaration]),
                      ]
                    : Validators.required;

                this.form.get("files").setValidators(validators);
                this.form.get("data").setValidators(this.isEnergyCertification ? Validators.required : null);
                // MOT03 - certificação de gás + autodeclaracao
                // MOT02 - certificacao energetica
                return;
            case "02020600": // TERMINAR CONTRATO
            case "02170300": // ELIMINAR CONTA
                this.form.get("data").setValidators(Validators.required);
                return;
            case "02021100": // TARIFA SOCIAL
                this.form.get("files").setValidators(Validators.required);
                return;
            default:
                return;
        }
    }

    public resolved(event) {
        this.form.get("recaptchaToken").setValue(event);
    }

    public backStep() {
        this.goBack.emit();
    }

    get description() {
        return this.form.get("description").value;
    }
}
